module.exports = __webpack_public_path__ + "static/img/Picture1.1540d85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191017/Picture1.jpg
// module id = oD0G
// module chunks = 1